import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

export const executeActionOnSubmit = store.effects.create((feature: Feature) =>
  feature.actions.submitAction.request.observe().pipe(
    rxjs.mergeMap(action => {
      // We get the action operations using the API
      const executionResult$ = feature.api.submitAction(action.data)
      // TODO: after the first response, everything else should be a follow
      // up success or follow up error
      return executionResult$.pipe(
        // Handles success
        rxjs.map(executionResult =>
          feature.actions.submitAction.success.from(action).create({
            request: action.data,
            response: executionResult,
          }),
        ),
        // Handles error
        rxjs.catchError(error =>
          rxjs.of(
            feature.actions.submitAction.error.from(action).create({
              error,
              request: action.data,
            }),
          ),
        ),
      )
    }),
  ),
)
